import { setPublicPath } from "systemjs-webpack-interop";

setPublicPath("@dm-portal/auth");
